import { render, staticRenderFns } from "./ModalEditarRequestHeadersRequisicao.vue?vue&type=template&id=31ea68c0&scoped=true"
import script from "./ModalEditarRequestHeadersRequisicao.vue?vue&type=script&lang=js"
export * from "./ModalEditarRequestHeadersRequisicao.vue?vue&type=script&lang=js"
import style0 from "./ModalEditarRequestHeadersRequisicao.vue?vue&type=style&index=0&id=31ea68c0&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31ea68c0",
  null
  
)

export default component.exports